/**
 * Minimal YAML parser for split.local.yml / split.local.override.yml.
 * Supports comment lines, blank lines, and `key: value` pairs (quoted or unquoted).
 */
export function parseSplitLocalYaml(content: string): Record<string, string> {
  const result: Record<string, string> = {};

  for (let line of content.split(/\r?\n/)) {
    const commentIndex = line.indexOf('#');
    if (commentIndex !== -1) {
      line = line.slice(0, commentIndex);
    }
    line = line.trim();
    if (!line) continue;

    const colon = line.indexOf(':');
    if (colon === -1) continue;

    const key = line.slice(0, colon).trim();
    let value = line.slice(colon + 1).trim();

    if (
      (value.startsWith('"') && value.endsWith('"')) ||
      (value.startsWith("'") && value.endsWith("'"))
    ) {
      value = value.slice(1, -1);
    }

    if (key) {
      result[key] = value;
    }
  }

  return result;
}
